import { TemplateConfig } from '../types';

export const crushSpreadConfig: TemplateConfig = {
  id: 'crush-spread',
  name: '暗恋crush牌阵',
  description: '洞察暗恋对象对你的真实感受与未来走向。',
  cardCount: 4,

  fieldDefaults: {
    title: '暗恋crush牌阵',
    customerQuestion: '看看对方对自己有没有好感，对自己的看法如何，以及未来会在一起吗？以及关系后续的走向。',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 2 行第 3 张牌'
    ],
    cardInfos: [
      '对方对我有没有好感',
      '对方对我的看法如何',
      '我和对方会在一起吗',
      '未来关系的走向'
    ]
  },

  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],

  generateOptions: {
    normal: true,
    thinking: true
  },

  ui: {
    color: '#722ed1',
    backgroundColor: '#f9f0ff',
    icon: '💘'
  }
};
